// Copyright (c) 2025 Deere & Company

import t from 'tcomb';

const RgaConsignmentDetails = t.struct({
    analysisDate: t.Number,
    componentSerialNumber: t.String,
    courierName: t.String,
    courierTrackingNo: t.String,
    engineHours: t.Number,
    engineSerialNumber: t.String,
    firstShipToLocation: t.String,
    followUpDate: t.Number,
    machineHours: t.Number,
    machineSerialNumber: t.String,
    model: t.String,
    partDescription: t.String,
    partNumber: t.String,
    processedDate: t.Number,
    requestType: t.String,
    requestedDate: t.Number,
    requestedPartQuantity: t.Number,
    requester: t.String,
    requesterType: t.String,
    rgaNumber: t.String,
    rgaRecallStatus: t.String,
    secondShipToLocation: t.String,
    shippedToDate: t.Number,
    shippingPriority: t.String,
    specialInstruction: t.String,
    warrantyClaimNumber: t.String
}, {
    name: 'RgaConsignmentDetails',
    strict: true
});

export const getDefaultState = () => new RgaConsignmentDetails({
    analysisDate: 0,
    componentSerialNumber: '',
    courierName: '',
    courierTrackingNo: '',
    engineHours: 0,
    engineSerialNumber: '',
    firstShipToLocation: '',
    followUpDate: 0,
    machineHours: 0,
    machineSerialNumber: '',
    model: '',
    partDescription: '',
    partNumber: '',
    processedDate: 0,
    requestType: '',
    requestedDate: 0,
    requestedPartQuantity: 0,
    requester: '',
    requesterType: '',
    rgaNumber: '',
    rgaRecallStatus: '',
    secondShipToLocation: '',
    shippedToDate: 0,
    shippingPriority: '',
    specialInstruction: '',
    warrantyClaimNumber: ''
});

export default RgaConsignmentDetails;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-consignment-details.js